import { QueryClient } from '@tanstack/react-query';

/**
 * Single QueryClient for the SPA. Defaults:
 *   - staleTime 5s: most dashboard data is polled every 10s, so 5s of
 *     staleness is fine and saves needless refetches.
 *   - refetchOnWindowFocus false: when the user alt-tabs back, do not
 *     slam the proxy with 6 simultaneous refetches.
 *   - retry once on transient errors; permanent errors (4xx) propagate
 *     immediately.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof Error && /4\d\d/.test(error.message)) return false;
        return failureCount < 1;
      },
    },
  },
});
